"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildServerTelemetry = buildServerTelemetry;
exports.buildCliTelemetry = buildCliTelemetry;
exports.flushOnExit = flushOnExit;
exports.startTelemetrySession = startTelemetrySession;
exports.maybeShowCliNotice = maybeShowCliNotice;
const fs = __importStar(require("fs"));
const path = __importStar(require("path"));
const dist_1 = require("../../telemetry/dist");
const events_1 = require("../../app/dist/telemetry/events");
/**
 * PostHog project key — public/write-only, safe to ship. Inlined into the CLI
 * bundle at build time via the esbuild `define` for `process.env.LOOM_POSTHOG_KEY`
 * (see packages/cli/esbuild.js). Empty ⇒ telemetry is structurally Noop, so a
 * key-less build never sends. The dev/standalone server reads it from the env.
 */
const POSTHOG_KEY = process.env.LOOM_POSTHOG_KEY ?? '';
/**
 * Warn once on stderr when the user opted in (`LOOM_TELEMETRY` truthy) but this
 * build has no PostHog key baked in (`POSTHOG_KEY` empty ⇒ structurally Noop). An
 * opted-in user would otherwise send nothing *silently* — exactly the failure a
 * local key-less `build-all.sh` produces (it never sets `LOOM_POSTHOG_KEY`, so the
 * esbuild `define` bakes `''`). Kept at the host layer on purpose: `packages/telemetry`
 * is silent by design and never writes to stderr.
 */
function warnIfEnabledButKeyless(env) {
    if ((0, dist_1.consentFromEnv)(env) && !POSTHOG_KEY) {
        process.stderr.write('⚠ Loom telemetry is ON but this build has no PostHog key baked in — ' +
            'events will NOT send. Rebuild with LOOM_POSTHOG_KEY set to enable.\n');
    }
}
/**
 * Build the telemetry client for a server process. Surface comes from
 * `LOOM_SURFACE` (the VS Code extension sets `extension` when it spawns
 * `loom mcp`; Claude Code leaves it unset ⇒ `agent`). Consent comes from
 * `LOOM_TELEMETRY`. Disabled or key-less ⇒ shared NoopTelemetry.
 */
function buildServerTelemetry(loomVersion, env = process.env) {
    const surface = env.LOOM_SURFACE || 'agent';
    warnIfEnabledButKeyless(env);
    return (0, dist_1.createTelemetry)({
        enabled: (0, dist_1.consentFromEnv)(env),
        surface,
        loomVersion,
        apiKey: POSTHOG_KEY || undefined,
        env,
    });
}
/**
 * Build the telemetry client for a CLI-direct invocation (surface `cli`). Same
 * consent/key gate; the surface is forced rather than read from env.
 */
function buildCliTelemetry(loomVersion, env = process.env) {
    warnIfEnabledButKeyless(env);
    return (0, dist_1.createTelemetry)({
        enabled: (0, dist_1.consentFromEnv)(env),
        surface: 'cli',
        loomVersion,
        apiKey: POSTHOG_KEY || undefined,
        env,
    });
}
/** Register a best-effort `flush()` on process exit so buffered events aren't lost. */
function flushOnExit(telemetry) {
    const flush = () => void telemetry.flush();
    process.once('SIGINT', flush);
    process.once('SIGTERM', flush);
    process.once('beforeExit', flush);
}
/**
 * Emit the once-per-process start events (`workspace_activated`, `session_started`)
 * and register the exit flush. Used by the long-lived MCP server processes.
 */
function startTelemetrySession(telemetry) {
    (0, events_1.trackWorkspaceActivated)(telemetry);
    (0, events_1.trackSessionStarted)(telemetry);
    flushOnExit(telemetry);
}
/**
 * Print the one-time CLI telemetry notice (opt-in disclosure for the terminal /
 * agent path, which has no interactive prompt). No-op if the user already made a
 * choice via `LOOM_TELEMETRY`, or if the notice was already shown (a benign marker
 * file in the config dir — not telemetry data, nothing is sent). Failures are
 * swallowed so a notice never disrupts the CLI.
 */
function maybeShowCliNotice(env = process.env) {
    if (env.LOOM_TELEMETRY !== undefined && env.LOOM_TELEMETRY.trim() !== '') {
        return;
    }
    try {
        const marker = path.join((0, dist_1.defaultConfigDir)(env), 'telemetry-notice');
        if (fs.existsSync(marker)) {
            return;
        }
        fs.mkdirSync(path.dirname(marker), { recursive: true });
        fs.writeFileSync(marker, new Date().toISOString(), 'utf8');
        process.stderr.write('ℹ Loom can collect anonymous, content-free usage telemetry (opt-in, off by default). ' +
            'Enable with LOOM_TELEMETRY=1; see the README for exactly what is sent.\n');
    }
    catch {
        /* never let a notice disrupt the CLI */
    }
}
